export default __webpack_public_path__ + "static/media/mintImage.90db68ba.png";